import script from "./ProjectGoalsExecution.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectGoalsExecution.vue?vue&type=script&setup=true&lang=js"

import "./ProjectGoalsExecution.vue?vue&type=style&index=0&id=92aab206&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92aab206"]])

export default __exports__